import React from 'react';
import { faGift } from '@fortawesome/free-solid-svg-icons';
import { WidgetContainer } from '@frontend/app/refresh-components';
import { PFAOrdersCost, PFAOrdersTypeBreakdown } from '@frontend/app/widgets';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { cn } from '@frontend/shadcn/lib/utils';
import { PFADashboardProvider } from '@frontend/app/containers/ProductFulfillmentDashboard/ProductFulfillmentDashboardContext';
import { ApolloProvider } from '@apollo/client';
import { useAppContext } from '@frontend/context/AppContext';

export const ProductOrderAnalysis = ({ projectId, className }: { projectId?: number; className?: string }) => {
  const { pfaApolloClient } = useAppContext();

  return (
    <PFADashboardProvider>
      <ApolloProvider client={pfaApolloClient}>
        <WidgetContainer
          widgetTitle="Product Order Analysis"
          textColor="text-grey-6 text-sm"
          bgColor="bg-white"
          widgetIcon={<FontAwesomeIcon icon={faGift} className="text-grey-4" />}
          className={cn('h-min', className)}
        >
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-2 xl:grid-cols-2 2xl:grid-cols-2">
            <PFAOrdersTypeBreakdown v2 programId={projectId} />
            <PFAOrdersCost v2 programId={projectId} />
          </div>
        </WidgetContainer>
      </ApolloProvider>
    </PFADashboardProvider>
  );
};
